<template>
    <div class="row">
        <div class="col-xl-2 col-md-3 col-sm-12" v-for="advertisement in advertisements" :key="advertisement.id">
            <div class="m-1 p-1 girl" >
                <router-link :to="{ name: 'Show', params: {'id': advertisement.id, 'slug': slugify(advertisement.name)}}">
                    <img class="card-img-top" :src="`${cdn_url}/resized/${advertisement.pictures[1].name.replace('.jpg', '.webp')}`" :alt="`${advertisement.name} Escort Girl`">
                </router-link>
                <div class="card-body">
                    <h5 class="card-text text-uppercase"><router-link :to="{ name: 'Show', params: {'id': advertisement.id, 'slug': slugify(advertisement.name)}}">{{ advertisement.name }}</router-link></h5>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdsComponent",
        props: [ 'advertisements' ],
        data() {
            return {
                cdn_url: process.env.VUE_APP_CDN_URL
            }
        },
        methods: {
            slugify(text)
            {
                return text.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');
            }
        }
    }
</script>

<style scoped>

</style>
